import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef flag to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('No session found');
        navigate('/login');
        return;
      }

      try {
        // Get stored role from registration page (if coming from register)
        const storedRole = localStorage.getItem('utentik_register_role');
        localStorage.removeItem('utentik_register_role');
        const user = await handleGoogleCallback(sessionId, storedRole);
        toast.success('¡Bienvenido!');
        navigate(user.role === 'creator' ? '/dashboard' : '/prelanzamiento', { replace: true });
      } catch (error) {
        toast.error('Error al iniciar sesión');
        navigate('/login');
      }
    };

    processCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="text-center">
        <div className="inline-block w-12 h-12 border-4 border-[#22BCB9] border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-slate-600">Procesando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
